import React, { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';

import ChaptersAdminPage from './ChaptersAdminPage';

const ChaptersRouter = (): ReactElement => (
  <Routes>
    <Route path="*" element={<ChaptersAdminPage />} />
  </Routes>
);

export default ChaptersRouter;
